import React from "react";
import theme from "theme";
import { Theme, Link, Text, Box, Span, Image, Hr, Em, Strong, Icon, Section, LinkBox } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { IoIosArrowDown } from "react-icons/io";
import { FaBolt } from "react-icons/fa";
import { MdVerifiedUser, MdAttachMoney } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"index"} />
		<Helmet>
			<title>
				Aid-vertise - Turning Ads into Aid
			</title>
			<meta name={"description"} content={"Aid-vertise transforms your browser into a solution that raises money for disability charities. With every new tab, you help fund social programs, post-secondary scholarships, and medical services for people with disabilities & developmental needs. "} />
			<meta property={"og:title"} content={"Aid-vertise - Turning Ads into Aid"} />
			<meta property={"og:description"} content={"Aid-vertise transforms your browser into a solution that raises money for disability charities. With every new tab, you help fund social programs, post-secondary scholarships, and medical services for people with disabilities & developmental needs. "} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.jpg?v=2024-01-06T18:39:53.403Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024.png?v=2023-03-05T21:23:37.784Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2024%20%281%29.jpg?v=2024-01-06T18:29:44.221Z"} />
			<meta name={"msapplication-TileColor"} content={"#8336ff"} />
		</Helmet>
		<Components.Navbar />
		<Section
			quarkly-title="HeroBlock"
			height="100%"
			md-height="100%"
			align-items="center"
			justify-content="center"
			padding="24px 0 50px 0"
			sm-padding="10px 0 30px 0"
		>
			<Override
				slot="SectionContent"
				flex-direction="column"
				position="relative"
				z-index="9"
				md-flex-wrap="wrap"
				md-z-index="7"
				md-flex-direction="column"
				height="100%"
				sm-margin="80px 15px 0px 15px"
				lg-margin="100px 49.5938px 0px 49.5938px"
				id="home"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				display="flex"
				md-flex-direction="column-reverse"
				margin="30px 0px 0px 0px"
				md-width="100%"
				md-align-items="center"
				md-margin="30px 0px 0px 0px"
			>
				<Box min-width="100px" min-height="100px" width="50%" md-width="100%">
					<Box
						display="flex"
						margin="90px 0px 20px 0px"
						align-items="center"
						sm-width="100%"
						lg-margin="0px 0px 10px 0px"
						md-justify-content="center"
						md-margin="20px 0px 10px 0px"
						sm-margin="20px 0px 0px 0px"
					>
						<Text
							margin="0px 0px 0px 0px"
							color="--blue"
							font="normal 500 18px/1.6 --fontFamily-googleInter"
							lg-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
							md-font="normal 500 14px/1.6 &quot;Inter&quot;, sans-serif"
						>
							JOIN US IN TURNING ADS INTO AID
						</Text>
					</Box>
					<Box
						empty-min-width="64px"
						empty-min-height="64px"
						empty-border-width="1px"
						empty-border-style="solid"
						empty-border-color="LightGray"
						flex-direction="column"
						display="flex"
						align-items="flex-start"
						md-width="100%"
						justify-content="center"
						width="100%"
						md-padding="0px 0px 0px 0px"
						md-align-items="center"
					>
						<Text
							lg-text-align="left"
							lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
							md-font="normal 700 50px/1.2 &quot;Inter&quot;, sans-serif"
							margin="0px 0px 15px 0px"
							font="normal 600 50px/1.2 --fontFamily-googlePoppins"
							color="#374151"
							sm-font="normal 500 34px/1.2 &quot;Inter&quot;, sans-serif"
							md-width="100%"
							width="90%"
							md-text-align="center"
							md-margin="10px 0px 16px 0px"
						>
							<Span
								font-weight="normal"
								lg-font="600 40px/48px --fontFamily-googlePoppins"
								font="600 50px/60px --fontFamily-googlePoppins"
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
								sm-font="600 38px/48px --fontFamily-googlePoppins"
							>
								Support disability charities, for free & with ease
							</Span>
						</Text>
						<Text
							font="normal 400 18px/1.5 --fontFamily-googleInter"
							lg-text-align="left"
							lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
							md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
							margin="15px 0px 0px 0px"
							color="#374151"
							opacity="1"
							width="90%"
							md-text-align="center"
							md-margin="0px 0px 0px 0px"
							lg-margin="10px 0px 0px 0px"
							md-width="100%"
						>
							Transform your browser into a solution that raises money for disability charities. With every new tab, you can help fund people with disabilities & developmental needs.{" "}
						</Text>
						<Box
							md-width="100%"
							md-margin="36px 0px 0px 0px"
							display="flex"
							margin="40px 0px 0px 0px"
							md-align-items="center"
							md-justify-content="center"
							width="100%"
							sm-flex-direction="column"
							sm-padding="0px 0px 0px 0px"
						>
							<Link
								transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
								href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
								text-decoration-line="initial"
								sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
								md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
								md-text-align="center"
								lg-margin="0px 32px 0px 0px"
								border-radius="5px"
								color="--white"
								lg-padding="7px 15px 7px 15px"
								md-width="50%"
								background="#8336ff"
								font="normal 500 16px/1.3 --fontFamily-googleInter"
								border-style="none"
								sm-width="100%"
								sm-margin="0px 0px 20px 0px"
								margin="0px 25px 0px 0px"
								padding="15px 30px 15px 30px"
								hover-background="#6608ff"
								hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
								lg-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
								md-padding="15px 16px 15px 16px"
								lg-display="flex"
								lg-align-items="center"
								lg-justify-content="center"
								text-align="center"
								target="_blank"
							>
								Try Aid-vertise Now
							</Link>
							<Link
								font="normal 500 16px/1.3 &quot;Inter&quot;, sans-serif"
								border-radius="5px"
								transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
								lg-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
								border-style="solid"
								md-width="50%"
								md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
								md-text-align="center"
								text-decoration-line="initial"
								color="--indigo"
								background="rgba(255, 5, 5, 0)"
								margin="0px 0px 0px 0px"
								sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
								hover-color="--indigo"
								href="/#purpose"
								lg-padding="15px 23px 15px 23px"
								md-padding="15px 16px 15px 16px"
								border-color="#cbd5e1"
								border-width="1px"
								sm-width="100%"
								padding="15px 30px 15px 30px"
								hover-background="rgba(131, 54, 255, 0.07)"
								hover-border-color="--color-indigo"
								text-align="center"
							>
								Learn More
							</Link>
						</Box>
						<Box
							lg-margin="32px 0px 0px 0px"
							md-width="100%"
							md-margin="36px 0px 0px 0px"
							display="flex"
							margin="30px 0px 0px 0px"
						/>
					</Box>
					<Text margin="0px 0px 0px 0px" font="700 20px/24px --fontFamily-sans" color="--indigo" border-color="#ffffff" />
				</Box>
				<Box
					min-width="100px"
					min-height="100px"
					width="50%"
					display="flex"
					align-items="center"
					align-content="center"
					justify-content="center"
					md-justify-content="center"
					md-align-items="center"
					md-width="100%"
				>
					<Image
						src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22:24:16.543Z"
						display="block"
						min-width="400px"
						margin="60px 0px 0px 0px"
						lg-margin="0px 0px 0px 0px"
						md-width="80%"
						sm-min-width="200px"
						sm-width="80%"
						srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20240%20%281%29.png?v=2024-01-02T22%3A24%3A16.543Z&quality=85&w=3200 3200w"
						sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Hr min-height="10px" min-width="100%" margin="70px 0px 0px 0px" sm-margin="20px 0px 0px 0px" />
			<Box
				min-width="100px"
				min-height="100px"
				display="flex"
				align-items="center"
				justify-content="center"
				flex-direction="column"
			>
				<Text
					font="normal 400 14px/1.5 --fontFamily-googleInter"
					lg-font="normal 400 14px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					color="--darkL2"
					opacity="1"
					width="100%"
					md-text-align="center"
					md-margin="0px 0px 0px 0px"
					lg-margin="10px 0px 0px 0px"
					md-width="100%"
					text-align="center"
					margin="0px 0px 0px 0px"
				>
					See how it works and what you can do with
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{" "}Aid-
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							vertise
						</Em>
					</Strong>
				</Text>
				<Link href="/#overview">
					<Icon
						category="io"
						icon={IoIosArrowDown}
						size="25px"
						color="--darkL2"
						width="40px"
						height="30px"
						hover-transform="translateY(3px)"
						transition="all .3s ease 0s"
					/>
				</Link>
			</Box>
		</Section>
		<Section padding="50px 0 70px 0" id="overview">
			<Override slot="SectionContent" display="flex" align-items="center" justify-content="center" />
			<Box
				min-width="100px"
				min-height="100px"
				width="100%"
				align-self="center"
				display="flex"
				align-items="center"
				justify-content="center"
				margin="0px 0px 0px 0px"
				flex-direction="column"
			>
				<Text
					margin="0px 0px 20px 0px"
					font="normal 500 40px/1 --fontFamily-googlePoppins"
					text-align="center"
					color="#374151"
					lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					sm-width="100%"
					sm-font="normal 600 26px/1.3 &quot;Inter&quot;, sans-serif"
					sm-margin="0px 0px 0px 0px"
				>
					<Span
						font-weight="normal"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						font="600 50px/65px --fontFamily-googlePoppins"
						sm-font="600 26px/35px Inter, sans-serif"
						color="--indigo"
					>
						It's simple.
					</Span>
					<Span
						font-weight="normal"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						font="600 50px/65px --fontFamily-googlePoppins"
						sm-font="600 26px/35px Inter, sans-serif"
					>
						{" "}Raise funds.{" "}
						<br />
						Level up your productivity.
					</Span>
				</Text>
				<Text
					font="normal 400 18px/1.5 --fontFamily-googleInter"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					color="#374151"
					width="80%"
					text-align="center"
					sm-width="100%"
					border-color="--color-darkL2"
					opacity=".8"
				>
					Supercharge your browsing experience with the power of{" "}
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Aid-
					</Strong>
					<Em
						font-weight="bold"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						vertise.
					</Em>
				</Text>
			</Box>
			<Image
				src="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ezgif.com-crop%20%283%29.gif?v=2024-01-04T05:02:35.286Z"
				display="flex"
				width="70%"
				align-items="center"
				justify-content="center"
				border-radius="10px"
				margin="20px 0px 0px 0px"
				lg-width="100%"
			/>
		</Section>
		<Section padding="60px 0 60px 0" id="purpose" background="#f8fafc linear-gradient(0deg,rgba(0,0,0,0) 0%,#f8fafc 100%)">
			<Override
				slot="SectionContent"
				flex-direction="row"
				md-flex-wrap="wrap"
				md-align-items="center"
				md-justify-content="center"
			/>
			<Box
				width="50%"
				flex-direction="column"
				md-width="100%"
				empty-min-width="64px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				padding="16px 16px 16px 16px"
				display="flex"
				align-items="flex-start"
				justify-content="center"
				empty-min-height="64px"
				empty-border-width="1px"
				sm-padding="16px 0px 16px 0px"
			>
				<Image
					position="static"
					lg-left="0px"
					md-width="100%"
					border-radius="5px"
					lg-max-height="366px"
					src="https://uploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21:48:31.356Z"
					left="-140px"
					max-width="100%"
					object-fit="cover"
					display="block"
					srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/iStock-1156302874-960x540.jpg?v=2022-12-21T21%3A48%3A31.356Z&quality=85&w=3200 3200w"
					sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
				/>
			</Box>
			<Box
				justify-content="space-between"
				empty-min-height="64px"
				empty-border-style="solid"
				width="50%"
				display="flex"
				md-width="100%"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-color="LightGray"
				flex-direction="column"
				align-items="flex-start"
				sm-padding="16px 0px 16px 0px"
				padding="20px 20px 20px 20px"
			>
				<Box display="flex" margin="0px 0px 20px 0px" align-items="center" sm-width="100%">
					<Text
						margin="0px 0px 0px 0px"
						color="#cdafff"
						font="--lead"
						lg-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
						md-font="normal 500 14px/1.6 &quot;Inter&quot;, sans-serif"
					>
						OVER ONE BILLION PEOPLE HAVE A DISABILITY
					</Text>
				</Box>
				<Text
					width="88%"
					lg-width="100%"
					lg-font="normal 700 34px/1.2 &quot;Inter&quot;, sans-serif"
					md-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					margin="0px 0px 16px 0px"
					font="normal 600 40px/1.4 --fontFamily-googleInter"
					color="--dark"
					sm-font="normal 800 28px/1.4 &quot;Inter&quot;, sans-serif"
					text-align="left"
				>
					<Span
						font-weight="normal"
						sm-font="600 28px/1.2 Inter, sans-serif"
						font="600 40px/45px --fontFamily-googlePoppins"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						One billion reasons for one powerful plugin
					</Span>
				</Text>
				<Text
					font="normal 400 18px/1.5 &quot;Inter&quot;, sans-serif"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					margin="0px 0px 25px 0px"
					width="80%"
					color="#374151"
					border-color="--color-darkL2"
					lg-width="100%"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Aid-
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							vertise{" "}
						</Em>
					</Strong>
					is the easiest and most convenient way to make a real, positive impact. Simply open a new tab to start making a difference.
				</Text>
				<Link
					href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
					sm-padding="15px 20px 15px 20px"
					hover-background="#6608ff"
					border-width="0px"
					border-style="solid"
					font="normal 500 18px/1.8 --fontFamily-googleInter"
					sm-margin="0px 22px 0px 0px"
					border-color="rgba(255, 255, 255, 0.3)"
					md-width="100%"
					md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
					text-decoration-line="initial"
					color="--white"
					md-text-align="center"
					border-radius="5px"
					sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
					transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
					background="--color-indigo"
					md-margin="16px 0px 0px 0px"
					padding="10px 30px 10px 30px"
					hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
					target="_blank"
				>
					Download for Free
				</Link>
			</Box>
		</Section>
		<Section padding="60px 0 60px 0" id="purpose" background="#f8fafc linear-gradient(180deg,rgba(0,0,0,0) 0%,#f8fafc 100%)">
			<Override
				slot="SectionContent"
				flex-direction="row"
				md-flex-wrap="wrap"
				md-align-items="center"
				md-justify-content="center"
				md-flex-direction="column-reverse"
			/>
			<Box
				justify-content="space-between"
				empty-min-height="64px"
				empty-border-style="solid"
				width="50%"
				display="flex"
				md-width="100%"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-color="LightGray"
				flex-direction="column"
				align-items="flex-start"
				sm-padding="16px 0px 16px 0px"
				padding="20px 20px 20px 20px"
			>
				<Box display="flex" margin="0px 0px 20px 0px" align-items="center" sm-width="100%">
					<Text
						margin="0px 0px 0px 0px"
						color="#cdafff"
						font="--lead"
						lg-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
						md-font="normal 500 14px/1.6 &quot;Inter&quot;, sans-serif"
					>
						EASY, EFFORTLESS, & FREE
					</Text>
				</Box>
				<Text
					width="90%"
					lg-width="100%"
					lg-font="normal 700 34px/1.2 &quot;Inter&quot;, sans-serif"
					md-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					margin="0px 0px 16px 0px"
					font="normal 600 40px/1.4 --fontFamily-googleInter"
					color="--dark"
					sm-font="normal 800 28px/1.4 &quot;Inter&quot;, sans-serif"
					text-align="left"
				>
					<Span
						font-weight="normal"
						sm-font="600 27px/1.2 Inter, sans-serif"
						font="600 40px/45px --fontFamily-googlePoppins"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Make a difference with every new tab you open
						<br />
					</Span>
				</Text>
				<Text
					font="--base"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					margin="0px 0px 25px 0px"
					width="80%"
					color="#374151"
					border-color="--color-darkL2"
					lg-width="100%"
				>
					We are one of the first and only social-impact productivity dashboards, uniquely empowering you to create impact and elevate your daily online workflow.
				</Text>
				<Link
					href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
					sm-padding="15px 20px 15px 20px"
					hover-background="#6608ff"
					border-width="0px"
					border-style="solid"
					font="normal 500 18px/1.8 --fontFamily-googleInter"
					sm-margin="0px 22px 0px 0px"
					border-color="rgba(255, 255, 255, 0.3)"
					md-width="100%"
					md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
					text-decoration-line="initial"
					color="--white"
					md-text-align="center"
					border-radius="5px"
					sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
					transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
					background="--color-indigo"
					md-margin="16px 0px 0px 0px"
					padding="10px 30px 10px 30px"
					hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
					target="_blank"
				>
					Get Aid-
					<Em>
						vertise{" "}
					</Em>
					Today
				</Link>
			</Box>
			<Box
				width="50%"
				flex-direction="column"
				md-width="100%"
				empty-min-width="64px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				display="flex"
				align-items="flex-start"
				justify-content="flex-start"
				empty-min-height="64px"
				empty-border-width="1px"
				md-align-items="flex-start"
				position="relative"
				md-height="380px"
				sm-height="210px"
			>
				<Components.Youtube />
			</Box>
		</Section>
		<Section padding="50px 0 60px 0" sm-padding="50px 0 50px 0" id="steps" md-padding="50px 0 0px 0">
			<Override
				slot="SectionContent"
				flex-direction="row"
				md-flex-wrap="wrap"
				md-align-items="center"
				md-justify-content="center"
				md-padding="0px 0px 50px 0px"
				sm-padding="0px 0px 0px 0px"
				display="block"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				align-items="center"
				display="flex"
				justify-content="center"
				margin="0px 0px 30px 0px"
			>
				<Text
					font="normal 600 40px/1 --fontFamily-googleInter"
					text-align="center"
					color="#374151"
					lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					sm-width="100%"
					sm-font="normal 600 30px/1.2 &quot;Inter&quot;, sans-serif"
					width="100%"
					sm-margin="0px 0px 0px 0px"
					margin="0px 0px 0px 0px"
				>
					<Span
						font-weight="normal"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						sm-font="600 32px/36px Inter, sans-serif"
						font="600 40px/40px --fontFamily-googlePoppins"
					>
						Aid-
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							vertise
						</Em>
						{" "}works in just{" "}
						<Span
							color="--indigo"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							3 steps
						</Span>
					</Span>
				</Text>
			</Box>
			<Box min-width="100px" min-height="100px" display="flex" md-flex-direction="column">
				<Box
					justify-content="center"
					empty-min-height="64px"
					empty-border-style="solid"
					width="50%"
					padding="16px 50px 16px 16px"
					display="flex"
					md-width="100%"
					empty-min-width="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					flex-direction="column"
					align-items="flex-start"
					sm-padding="16px 0px 16px 0px"
					md-padding="16px 0px 16px 0px"
				>
					<Box display="flex" margin="0px 0px 20px 0px" align-items="center" sm-width="100%" />
					<Box
						min-width="50px"
						min-height="50px"
						background="--color-indigo"
						border-radius="100px"
						display="flex"
						justify-content="center"
						align-items="center"
						pointer-events="auto"
						width="50px"
					>
						<Text
							margin="0px 0px 0px 0px"
							font="700 25px/24px --fontFamily-googleInter"
							color="#ffffff"
							pointer-events="none"
							user-select="none"
						>
							1
						</Text>
					</Box>
					<Text
						width="95%"
						lg-width="100%"
						lg-font="normal 700 34px/1.2 &quot;Inter&quot;, sans-serif"
						md-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
						font="normal 600 40px/1.4 --fontFamily-googleInter"
						color="--dark"
						sm-font="normal 800 28px/1.4 &quot;Inter&quot;, sans-serif"
						text-align="left"
						margin="50px 0px 16px 0px"
						md-margin="30px 0px 16px 0px"
					>
						<Span
							font-weight="normal"
							sm-font="600 28px/39.2px Inter, sans-serif"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
							font="600 40px/56px --fontFamily-googlePoppins"
						>
							Install
						</Span>
					</Text>
					<Text
						font="--base"
						lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
						md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
						width="90%"
						color="#374151"
						border-color="--color-darkL2"
						md-margin="0px 0px 16px 0px"
						md-width="100%"
					>
						Download{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Aid-
							<Em
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								vertise
							</Em>
						</Strong>
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							{" "}
						</Em>
						onto your favorite browser in less than 30 seconds, gaining access to our unique, impact-driven dashboard.
					</Text>
				</Box>
				<Box
					width="50%"
					flex-direction="column"
					md-width="100%"
					empty-min-width="64px"
					empty-border-style="solid"
					empty-border-color="LightGray"
					display="flex"
					align-items="flex-start"
					justify-content="center"
					empty-min-height="64px"
					empty-border-width="1px"
					sm-padding="16px 0px 16px 0px"
					md-align-items="center"
				>
					<Image
						position="static"
						lg-left="0px"
						border-radius="5px"
						lg-max-height="366px"
						src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02:46:31.295Z"
						left="-140px"
						max-width="100%"
						object-fit="cover"
						display="block"
						width="100%"
						md-width="70%"
						sm-width="90%"
						srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2067.png?v=2023-01-29T02%3A46%3A31.295Z&quality=85&w=3200 3200w"
						sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
					/>
				</Box>
			</Box>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="0px 0 0px 0" md-padding="50px 0 24px 0">
			<Override
				slot="SectionContent"
				flex-direction="row"
				md-flex-wrap="wrap"
				md-align-items="center"
				md-justify-content="center"
				md-flex-direction="column-reverse"
			/>
			<Box
				flex-direction="column"
				md-width="100%"
				empty-min-width="64px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				display="flex"
				align-items="flex-start"
				justify-content="center"
				empty-min-height="64px"
				empty-border-width="1px"
				sm-padding="16px 0px 16px 0px"
				width="55%"
				md-padding="0px 0px 50px 0px"
				md-align-items="center"
			>
				<Image
					position="static"
					lg-left="0px"
					md-width="70%"
					border-radius="5px"
					lg-max-height="366px"
					src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22:25:32.161Z"
					left="-140px"
					max-width="100%"
					object-fit="cover"
					display="block"
					sm-width="90%"
					srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2069.png?v=2024-01-02T22%3A25%3A32.161Z&quality=85&w=3200 3200w"
					sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
				/>
			</Box>
			<Box
				justify-content="center"
				empty-min-height="64px"
				empty-border-style="solid"
				width="50%"
				padding="16px 16px 16px 50px"
				display="flex"
				md-width="100%"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-color="LightGray"
				flex-direction="column"
				align-items="flex-start"
				sm-padding="16px 0px 16px 0px"
				md-padding="16px 0px 16px 0px"
			>
				<Box display="flex" margin="0px 0px 20px 0px" align-items="center" sm-width="100%" />
				<Box
					min-width="50px"
					min-height="50px"
					background="--color-indigo"
					border-radius="100px"
					display="flex"
					justify-content="center"
					align-items="center"
					pointer-events="auto"
					width="50px"
				>
					<Text
						margin="0px 0px 0px 0px"
						font="700 25px/24px --fontFamily-googleInter"
						color="#ffffff"
						pointer-events="none"
						user-select="none"
					>
						2
					</Text>
				</Box>
				<Text
					width="95%"
					lg-width="100%"
					lg-font="normal 700 34px/1.2 &quot;Inter&quot;, sans-serif"
					md-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					font="normal 600 40px/1.4 --fontFamily-googlePoppins"
					color="--dark"
					sm-font="normal 600 28px/1.4 &quot;Inter&quot;, sans-serif"
					text-align="left"
					margin="50px 0px 16px 0px"
					md-margin="30px 0px 16px 0px"
				>
					<Span
						font-weight="normal"
						sm-font="600 28px/39.2px Inter, sans-serif"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						font="600 40px/56px --fontFamily-googlePoppins"
					>
						Surf
					</Span>
				</Text>
				<Text
					font="--base"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					width="90%"
					color="#374151"
					border-color="--color-darkL2"
					md-margin="0px 0px 16px 0px"
					md-width="100%"
				>
					Continue{" "}
					<Em>
						doing you
					</Em>
					, and as you surf the web,{" "}
					<Strong>
						opening new tabs
					</Strong>
					, we'll place ads in areas that are proven to be least distracting to you.
				</Text>
			</Box>
		</Section>
		<Section padding="60px 0 100px 0" sm-padding="0px 0 50px 0" md-padding="50px 0 50px 0" id="reason">
			<Override
				slot="SectionContent"
				flex-direction="row"
				md-flex-wrap="wrap"
				md-align-items="center"
				md-justify-content="center"
			/>
			<Box
				justify-content="center"
				empty-min-height="64px"
				empty-border-style="solid"
				width="50%"
				padding="16px 16px 16px 16px"
				display="flex"
				md-width="100%"
				empty-min-width="64px"
				empty-border-width="1px"
				empty-border-color="LightGray"
				flex-direction="column"
				align-items="flex-start"
				sm-padding="16px 0px 16px 0px"
				md-padding="16px 0px 16px 0px"
			>
				<Box display="flex" margin="0px 0px 20px 0px" align-items="center" sm-width="100%" />
				<Box
					min-width="50px"
					min-height="50px"
					background="--color-indigo"
					border-radius="100px"
					display="flex"
					justify-content="center"
					align-items="center"
					pointer-events="auto"
					width="50px"
				>
					<Text
						margin="0px 0px 0px 0px"
						font="700 25px/24px --fontFamily-googleInter"
						color="#ffffff"
						pointer-events="none"
						user-select="none"
					>
						3
					</Text>
				</Box>
				<Text
					width="95%"
					lg-width="100%"
					lg-font="normal 700 34px/1.2 &quot;Inter&quot;, sans-serif"
					md-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					font="normal 600 40px/1.4 --fontFamily-googleInter"
					color="--dark"
					sm-font="normal 600 28px/1.4 &quot;Inter&quot;, sans-serif"
					text-align="left"
					margin="50px 0px 16px 0px"
					md-margin="30px 0px 16px 0px"
				>
					<Span
						font-weight="normal"
						sm-font="600 28px/39.2px Inter, sans-serif"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						font="600 40px/56px --fontFamily-googlePoppins"
					>
						Aid
					</Span>
				</Text>
				<Text
					font="--base"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					width="90%"
					color="#374151"
					border-color="--color-darkL2"
					md-width="100%"
					md-margin="0px 0px 16px 0px"
				>
					With every ad, you'll generate an ad impression, and these funds will be{" "}
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						directly
					</Strong>
					{" "}sent
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{" "}
					</Strong>
					to disability charities.
				</Text>
			</Box>
			<Box
				width="50%"
				flex-direction="column"
				md-width="100%"
				empty-min-width="64px"
				empty-border-style="solid"
				empty-border-color="LightGray"
				display="flex"
				align-items="flex-start"
				justify-content="center"
				empty-min-height="64px"
				empty-border-width="1px"
				sm-padding="16px 0px 16px 0px"
				md-align-items="center"
				md-padding="0px 0px 50px 0px"
			>
				<Image
					position="static"
					lg-left="0px"
					md-width="65%"
					border-radius="5px"
					lg-max-height="366px"
					src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04:44:06.117Z"
					left="-140px"
					max-width="100%"
					object-fit="cover"
					display="block"
					sm-width="90%"
					srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2074%20%281%29.png?v=2023-01-29T04%3A44%3A06.117Z&quality=85&w=3200 3200w"
					sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
				/>
			</Box>
		</Section>
		<Section
			md-padding="60px 0 60px 0"
			padding="84px 0 0px 0"
			sm-padding="60px 0 40px 0"
			align-items="center"
			display="flex"
			justify-content="center"
			id="features"
			background="rgba(0, 0, 0, 0) linear-gradient(0deg,rgba(0,0,0,0) 72.9%,#f8fafc 100%) 0% 0% /auto repeat scroll padding-box"
		>
			<Override
				slot="SectionContent"
				flex-wrap="wrap"
				flex-direction="column"
				display="flex"
				justify-content="center"
			/>
			<Text margin="0px 0px 0px 0px" />
			<Box
				min-width="100px"
				min-height="100px"
				width="100%"
				align-self="center"
				display="flex"
				align-items="center"
				justify-content="center"
				margin="0px 0px 30px 0px"
				flex-direction="column"
			>
				<Text
					margin="0px 0px 20px 0px"
					font="normal 500 40px/1 --fontFamily-googlePoppins"
					text-align="center"
					width="77%"
					color="#374151"
					lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
					sm-width="100%"
					sm-font="normal 600 28px/1.3 &quot;Inter&quot;, sans-serif"
					md-width="100%"
					lg-width="90%"
				>
					<Span
						font-weight="normal"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
						font="600 50px/65px --fontFamily-googlePoppins"
						sm-font="600 27px/35px Inter, sans-serif"
					>
						Get started with Aid-
						<Em
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							vertise{" "}
						</Em>
						for free to quickly & easily{" "}
						<Span
							color="--indigo"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							make an impact{" "}
						</Span>
					</Span>
				</Text>
				<Text
					font="normal 400 18px/1.5 --fontFamily-googleInter"
					lg-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					md-font="normal 400 16px/1.5 &quot;Inter&quot;, sans-serif"
					color="#374151"
					width="80%"
					text-align="center"
					sm-width="100%"
					border-color="--color-darkL2"
					opacity=".8"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Aid-
					</Strong>
					<Em
						font-weight="bold"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						vertise{" "}
					</Em>
					offers a suite of apps, widgets, and features that are entirely customizable to your needs.
				</Text>
			</Box>
			<Image
				src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22:23:09.825Z"
				display="block"
				width="100%"
				height="Auto"
				srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20241%20%281%29.png?v=2024-01-02T22%3A23%3A09.825Z&quality=85&w=3200 3200w"
				sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
			/>
		</Section>
		<Section sm-padding="0px 0 80px 0" md-padding="0px 0 50px 0" padding="0px 0 100px 0">
			<Override
				slot="SectionContent"
				display="flex"
				grid-gap="16px"
				grid-template-columns="repeat(4, 1fr)"
				lg-grid-gap="0px"
				md-grid-template-columns="repeat(2, 1fr)"
				align-self="center"
				order="0"
				flex-direction="column"
				justify-content="center"
				md-align-items="center"
			/>
			<Box
				min-width="100px"
				min-height="50px"
				display="flex"
				align-items="flex-start"
				justify-content="center"
				align-content="center"
				margin="20px 0px 0px 0px"
				sm-flex-direction="column"
				md-flex-direction="column"
				pointer-events="none"
				md-align-items="center"
			>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="33.333%"
					md-width="100%"
					lg-width="50%"
					padding="32px 25px 32px 25px"
					border-width="2px"
					border-style="solid"
					border-color="rgba(66, 82, 207, 0.1)"
					margin="16px 16px 16px 16px"
					border-radius="10px"
					pointer-events="auto"
				>
					<Box
						min-width="50px"
						min-height="50px"
						background="--color-indigo"
						border-radius="100px"
						display="flex"
						justify-content="center"
						align-items="center"
						pointer-events="auto"
						width="50px"
					>
						<Icon
							category="fa"
							icon={FaBolt}
							size="32px"
							color="#ffffff"
							pointer-events="none"
						/>
					</Box>
					<Text
						color="--dark"
						font="normal 500 24px/1.6 --fontFamily-googlePoppins"
						margin="32px 0px 8px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						Super Fast
					</Text>
					<Text
						color="--darkL2"
						font="--textBase"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						Requiring only two clicks and 30 seconds,{" "}
						<Strong pointer-events="none" user-select="none">
							Aid-
							<Em pointer-events="none" user-select="none">
								vertise{" "}
							</Em>
						</Strong>
						is the easiest installation you'll ever make.{" "}
					</Text>
				</Box>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="33.333%"
					md-width="100%"
					lg-width="50%"
					padding="32px 25px 32px 25px"
					border-style="solid"
					border-width="2px"
					border-color="rgba(66, 82, 207, 0.1)"
					margin="16px 16px 16px 16px"
					border-radius="10px"
				>
					<Box
						min-width="50px"
						min-height="50px"
						background="--color-indigo"
						border-radius="100px"
						display="flex"
						justify-content="center"
						align-items="center"
						pointer-events="auto"
						width="50px"
					>
						<Icon
							category="md"
							icon={MdVerifiedUser}
							size="35px"
							color="#ffffff"
							pointer-events="none"
						/>
					</Box>
					<Text
						color="--dark"
						font="normal 500 24px/1.6 --fontFamily-googlePoppins"
						margin="32px 0px 8px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						Private & Secure
					</Text>
					<Text
						color="--darkL2"
						font="--textBase"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						Your privacy & security are our{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							#1 priority
						</Strong>
						<Span
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							. We
						</Span>
						{" "}never track or share your search browsing history.
					</Text>
				</Box>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="33.333%"
					md-width="100%"
					lg-width="50%"
					padding="32px 25px 32px 25px"
					border-style="solid"
					border-width="2px"
					border-color="rgba(66, 82, 207, 0.1)"
					margin="16px 16px 16px 16px"
					border-radius="10px"
				>
					<Box
						min-width="50px"
						min-height="50px"
						background="--color-indigo"
						border-radius="100px"
						display="flex"
						justify-content="center"
						align-items="center"
						pointer-events="auto"
						width="50px"
					>
						<Icon
							category="md"
							icon={MdAttachMoney}
							size="35px"
							color="#ffffff"
							pointer-events="none"
							padding="0px 0px 0px 2px"
						/>
					</Box>
					<Text
						color="--darkL2"
						font="normal 500 24px/1.6 --fontFamily-googlePoppins"
						margin="32px 0px 8px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						Real Money. Real Change.
					</Text>
					<Text
						color="--darkL2"
						font="--textBase"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="none"
					>
						Each placed ad generates an ad impression, creating revenue that is sent directly to charity.
					</Text>
				</Box>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				display="flex"
				align-items="center"
				justify-content="center"
				margin="20px 0px 0px 0px"
				md-width="100%"
			>
				<Link
					href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
					sm-padding="15px 20px 15px 20px"
					hover-background="#6608ff"
					border-width="0px"
					border-style="solid"
					font="normal 500 18px/1.8 --fontFamily-googleInter"
					border-color="rgba(255, 255, 255, 0.3)"
					md-width="100%"
					md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
					text-decoration-line="initial"
					color="--white"
					md-text-align="center"
					padding="10px 35px 10px 35px"
					border-radius="5px"
					sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
					transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
					background="--color-indigo"
					hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
					hover-border-width="0px"
					target="_blank"
				>
					Start making a difference now
				</Link>
			</Box>
		</Section>
		<Section
			padding="60px 0 90px 0"
			position="relative"
			lg-padding="60px 0 60px 0"
			md-padding="60px 0 60px 0"
			id="partners"
			sm-padding="60px 0 80px 0"
			background="#f8fafc"
		>
			<Override
				slot="SectionContent"
				lg-padding="0px 0px 0px 0px"
				max-width="1194px"
				flex-wrap="wrap"
				flex-direction="row"
			/>
			<Box
				lg-align-items="flex-start"
				flex-direction="row"
				justify-content="flex-start"
				margin="0px 0px 64px 0px"
				padding="16px 0px 16px 0px"
				lg-margin="0px 0px 24px 0px"
				sm-flex-wrap="wrap"
				display="flex"
				align-items="center"
				sm-margin="0px 0px 30px 0px"
				width="100%"
				md-flex-direction="column"
			>
				<Box
					width="40%"
					sm-width="100%"
					md-width="100%"
					md-margin="0px 0px 20px 0px"
					sm-font="700 30px/24px Montserrat, sans-serif"
				>
					<Text
						color="--dark"
						sm-margin="0px 0px 16px 0px"
						margin="0px 0px 0px 0px"
						font="600 40px/1.3 --fontFamily-googlePoppins"
						sm-font="600 28px/1.3 --fontFamily-googleInter"
						sm-text-align="center"
					>
						<Span
							font-weight="normal"
							sm-font="600 28px/36.4px Inter, sans-serif"
							font="600 40px/52px --fontFamily-googlePoppins"
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Charities we support
						</Span>
					</Text>
				</Box>
				<Box
					width="60%"
					sm-width="100%"
					lg-margin="0px 0px 0px 20px"
					sm-margin="0px 0px 0px 0px"
					margin="0px 0px 0px 0px"
					md-margin="0px 0px 0px 0px"
					md-width="100%"
				>
					<Text margin="0px 0px 0px 0px" font="--textBase" color="--darkL2">
						At{" "}
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							Aid-
							<Em
								overflow-wrap="normal"
								word-break="normal"
								white-space="normal"
								text-indent="0"
								text-overflow="clip"
								hyphens="manual"
								user-select="auto"
								pointer-events="auto"
							>
								vertise
							</Em>
						</Strong>
						, we are proud to support top nonprofits and institutions that are working to support people with disabilities. We carefully research and vet every organization we donate to, so you can trust that your support is making a real difference.{" "}
					</Text>
				</Box>
			</Box>
			<Box
				margin="0px 0px 0px 0px"
				sm-flex-wrap="wrap"
				sm-margin="0px 0px 0px 0px"
				justify-content="center"
				flex-wrap="wrap"
				width="100%"
				display="flex"
			>
				<Box
					border-style="solid"
					sm-padding="0px 0px 0px 0px"
					border-color="rgba(66, 82, 207, 0.1)"
					lg-padding="16px 16px 16px 16px"
					md-width="50%"
					sm-align-items="center"
					width="33.333%"
					padding="32px 74px 32px 74px"
					border-width="0px 1px 0px 0px"
					sm-justify-content="center"
					md-border-width="0px 1px 0px 0px"
				>
					<LinkBox href="https://www.easterseals.com/" target="_blank">
						<Box
							margin="0px 0px 0px 0px"
							width="100%"
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							align-items="center"
							lg-padding="18px 18px 18px 18px"
							sm-width="90%"
							padding="18px 25px 18px 25px"
							display="flex"
							justify-content="center"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01:15:05.791Z"
								sm-min-height="35px"
								width="170px"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/easterseals.png?v=2022-12-26T01%3A15%3A05.791Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
					</LinkBox>
				</Box>
				<Box
					sm-align-items="center"
					width="33.333%"
					border-color="rgba(66, 82, 207, 0.1)"
					lg-padding="16px 16px 16px 16px"
					sm-padding="0px 0px 0px 0px"
					sm-justify-content="center"
					padding="32px 74px 32px 74px"
					border-width="0px 1px 0px 1px"
					border-style="solid"
					md-width="50%"
					md-border-width="0px 0px 0px 1px"
				>
					<LinkBox href="https://inclusioncanada.ca/" target="_blank">
						<Box
							justify-content="center"
							margin="0px 0px 0px 0px"
							lg-padding="18px 18px 18px 18px"
							width="100%"
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							padding="18px 25px 18px 25px"
							display="flex"
							align-items="center"
							sm-width="90%"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17:00:47.008Z"
								width="140px"
								border-radius="5px"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/InclusionCanada-1-removebg-preview.png?v=2022-12-31T17%3A00%3A47.008Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
					</LinkBox>
				</Box>
				<Hr
					min-height="10px"
					display="none"
					md-display="block"
					min-width="100%"
					margin="0px 0px 0px 0px"
					md-margin="8px 0px 0px 0px"
					md-padding="0px 0px 6px 0px"
				/>
				<Box
					padding="32px 74px 32px 74px"
					border-style="solid"
					md-border-width="0px 1px 0px 0px"
					sm-justify-content="center"
					width="33.333%"
					border-width="0px 0px 0px 1px"
					border-color="rgba(66, 82, 207, 0.1)"
					lg-padding="16px 16px 16px 16px"
					md-width="50%"
					sm-padding="0px 0px 0px 0px"
					sm-align-items="center"
				>
					<LinkBox href="https://www.marchofdimes.ca/en-ca" target="_blank">
						<Box
							padding="18px 25px 18px 25px"
							display="flex"
							align-items="center"
							lg-padding="18px 18px 18px 18px"
							width="100%"
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							justify-content="center"
							margin="0px 0px 0px 0px"
							sm-width="90%"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image src="https://uploads.quarkly.io/63a25993f63de40026725928/images/modc_logo_en.svg?v=2022-12-29T15:13:49.781Z" sm-min-height="35px" width="140px" />
						</Box>
					</LinkBox>
				</Box>
				<Hr
					margin="32px 0px 32px 0px"
					lg-margin="16px 0px 16px 0px"
					md-display="none"
					width="100%"
					border-color="rgba(66, 82, 207, 0.1)"
					border-width="2px 0 0 0"
					border-style="solid"
					height="0px"
				/>
				<Box
					md-width="50%"
					sm-padding="0px 0px 0px 0px"
					sm-justify-content="center"
					padding="32px 74px 32px 74px"
					border-style="solid"
					border-color="rgba(66, 82, 207, 0.1)"
					sm-align-items="center"
					md-border-width="0px 0px 0px 1px"
					width="33.333%"
					border-width="0px 1px 0px 0px"
					lg-padding="16px 16px 16px 16px"
				>
					<LinkBox href="https://www.ctnsy.ca/" target="_blank">
						<Box
							width="100%"
							padding="18px 25px 18px 25px"
							display="flex"
							justify-content="center"
							margin="0px 0px 0px 0px"
							lg-padding="18px 18px 18px 18px"
							sm-width="90%"
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							align-items="center"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image
								sm-height="35px"
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17:00:31.927Z"
								width="250px"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/CTN_logo.png?v=2022-12-31T17%3A00%3A31.927Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
					</LinkBox>
				</Box>
				<Hr
					min-height="10px"
					display="none"
					md-display="block"
					min-width="100%"
					margin="0px 0px 0px 0px"
					md-margin="8px 0px 0px 0px"
					md-padding="0px 0px 6px 0px"
				/>
				<Box
					border-width="0px 1px 0px 1px"
					md-border-width="0px 1px 0px 0px"
					sm-align-items="center"
					md-width="50%"
					sm-padding="0px 0px 0px 0px"
					sm-justify-content="center"
					width="33.333%"
					padding="32px 74px 32px 74px"
					border-style="solid"
					border-color="rgba(66, 82, 207, 0.1)"
					lg-padding="16px 16px 16px 16px"
				>
					<LinkBox href="https://disabilityrightsfund.org/" target="_blank">
						<Box
							sm-width="90%"
							width="100%"
							padding="18px 25px 18px 25px"
							align-items="center"
							margin="0px 0px 0px 0px"
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							display="flex"
							justify-content="center"
							lg-padding="18px 18px 18px 18px"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17:00:19.246Z"
								sm-min-height="35px"
								width="150px"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Screen_Shot_2022-12-31_at_11.59.34_AM-removebg-preview.png?v=2022-12-31T17%3A00%3A19.246Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
					</LinkBox>
				</Box>
				<Box
					lg-padding="16px 16px 16px 16px"
					md-width="50%"
					md-border-width="0px 0px 0px 1px"
					padding="32px 74px 32px 74px"
					border-width="0px 0px 0px 1px"
					border-style="solid"
					width="33.333%"
					border-color="rgba(66, 82, 207, 0.1)"
					sm-padding="0px 0px 0px 0px"
				>
					<LinkBox href="https://newabilityonline.org/" target="_blank">
						<Box
							box-shadow="1px 4px 12px rgba(0, 0, 0, 0.08)"
							justify-content="center"
							margin="0px 0px 0px 0px"
							sm-width="90%"
							width="100%"
							padding="18px 25px 18px 25px"
							display="flex"
							align-items="center"
							lg-padding="18px 18px 18px 18px"
							height="109px"
							background="#ffffff"
							hover-background="rgba(255, 255, 255, 0)"
							transition="all 0.3s ease 0s"
						>
							<Image
								src="https://uploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15:18:28.480Z"
								sm-min-height="35px"
								width="150p"
								srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/abilityonline-logo.webp?v=2022-12-29T15%3A18%3A28.480Z&quality=85&w=3200 3200w"
								sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
							/>
						</Box>
					</LinkBox>
				</Box>
			</Box>
		</Section>
		<Section sm-padding="80px 0 80px 0" md-padding="0px 0 50px 0" padding="100px 0 100px 0" background="linear-gradient(0deg,rgba(0, 0, 0, 0.6) 0%,rgba(0, 0, 0, 0.2) 100%) 0% 0%/100%,rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/63a25993f63de40026725928/images/tropicalbonsai_wavey_purple_gradient_background_that_I_can_use__26d8530b-638f-47c7-a259-45115fe3d19c.png?v=2024-01-06T22:24:00.770Z) 0% 0% /cover repeat scroll padding-box">
			<Override
				slot="SectionContent"
				display="flex"
				grid-gap="16px"
				grid-template-columns="repeat(4, 1fr)"
				lg-grid-gap="0px"
				md-grid-template-columns="repeat(2, 1fr)"
				align-self="center"
				order="0"
				flex-direction="column"
				justify-content="center"
				md-align-items="center"
			/>
			<Text
				margin="0px 0px 0px 0px"
				font="normal 600 40px/1 --fontFamily-googlePoppins"
				text-align="center"
				width="100%"
				color="#ffffff"
				lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
				sm-width="100%"
				sm-font="normal 600 28px/1.3 &quot;Inter&quot;, sans-serif"
			>
				<Span
					font-size="50px"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					sm-font="600 38px/40px Inter, sans-serif"
				>
					<Span
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Trusted. Valued. Loved.
					</Span>
				</Span>
			</Text>
			<Box
				min-width="100px"
				min-height="50px"
				display="flex"
				align-items="flex-start"
				justify-content="center"
				align-content="center"
				margin="20px 0px 0px 0px"
				sm-flex-direction="column"
				md-flex-direction="column"
				pointer-events="none"
				md-align-items="center"
				lg-display="flex"
				lg-flex-direction="column"
				lg-align-items="center"
			>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="25%"
					md-width="100%"
					lg-width="50%"
					padding="25px 25px 25px 25px"
					border-width="0px"
					border-style="none"
					margin="16px 10px 16px 10px"
					border-radius="10px"
					pointer-events="auto"
					background="rgba(48, 0, 95, 0.6)"
					box-shadow="--m"
					transition="all 0.5s ease-in-out 0s"
					hover-background="rgba(192, 128, 255, 0.25) linear-gradient(120deg,rgba(0,0,0,0) 0%,rgba(62, 0, 137, 0.60) 100%)"
				>
					<Text
						color="white"
						font="400 16px/1.5 --fontFamily-googleInter"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						"It has been such a game changer to my workflow, all while supporting those in need. Amazing!"
					</Text>
					<Box
						min-width="100px"
						min-height="none"
						display="flex"
						flex-direction="row"
						align-content="center"
						align-items="center"
						justify-content="flex-start"
						margin="10px 0px 0px 0px"
					>
						<Image
							src="https://uploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20:58:46.260Z"
							display="block"
							width="65px"
							srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/slav-romanov-BrEAp01_m5w-unsplash%201.png?v=2024-01-08T20%3A58%3A46.260Z&quality=85&w=3200 3200w"
							sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							justify-content="center"
							margin="0px 0px 0px 15px"
						>
							<Text
								color="white"
								font="normal 500 20px/1.6 --fontFamily-googlePoppins"
								pointer-events="auto"
								user-select="auto"
								margin="0px 0px 0px 0px"
							>
								Tracy K.
							</Text>
							<Text margin="0px 0px 7px 0px" font="normal 400 14px/1.5 &quot;Inter&quot;, sans-serif" color="rgba(255, 255, 255, 0.50)">
								Beta User
							</Text>
							<Image src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21:49:07.643Z" display="block" srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=3200 3200w" sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw" />
						</Box>
					</Box>
				</Box>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="25%"
					md-width="100%"
					lg-width="50%"
					padding="25px 25px 25px 25px"
					border-style="none"
					margin="16px 10px 16px 10px"
					border-radius="10px"
					pointer-events="auto"
					background="rgba(48, 0, 95, 0.6)"
					border-width="0px"
					box-shadow="--m"
					transition="all 0.5s ease-in-out 0s"
					hover-background="rgba(192, 128, 255, 0.25) linear-gradient(120deg,rgba(0,0,0,0) 0%,rgba(62, 0, 137, 0.60) 100%)"
				>
					<Text
						color="white"
						font="400 16px/1.5 --fontFamily-googleInter"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						"Love the slick, customizable dashboard and easy-access apps. 10/10 would recommended!
						<Strong
							overflow-wrap="normal"
							word-break="normal"
							white-space="normal"
							text-indent="0"
							text-overflow="clip"
							hyphens="manual"
							user-select="auto"
							pointer-events="auto"
						>
							"
							<br />
						</Strong>
					</Text>
					<Box
						min-width="100px"
						min-height="none"
						display="flex"
						flex-direction="row"
						align-items="center"
						align-content="center"
						justify-content="flex-start"
						margin="10px 0px 0px 0px"
					>
						<Image
							src="https://uploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22:12:45.292Z"
							display="block"
							width="65px"
							srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/irene-strong-v2aKnjMbP_k-unsplash%201.png?v=2024-01-08T22%3A12%3A45.292Z&quality=85&w=3200 3200w"
							sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							justify-content="center"
							margin="0px 0px 0px 15px"
						>
							<Text
								color="white"
								font="normal 500 20px/1.6 --fontFamily-googlePoppins"
								pointer-events="auto"
								user-select="auto"
								margin="0px 0px 0px 0px"
							>
								Kyle S.
							</Text>
							<Text margin="0px 0px 7px 0px" font="normal 400 14px/1.5 &quot;Inter&quot;, sans-serif" color="rgba(255, 255, 255, 0.50)">
								Beta User
							</Text>
							<Image src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21:49:07.643Z" display="block" srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=3200 3200w" sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw" />
						</Box>
					</Box>
				</Box>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="25%"
					md-width="100%"
					lg-width="50%"
					padding="25px 25px 25px 25px"
					border-style="none"
					margin="16px 10px 16px 10px"
					border-radius="10px"
					pointer-events="auto"
					background="rgba(48, 0, 95, 0.6)"
					border-width="0px"
					box-shadow="--m"
					transition="all 0.5s ease-in-out 0s"
					hover-background="rgba(192, 128, 255, 0.25) linear-gradient(120deg,rgba(0,0,0,0) 0%,rgba(62, 0, 137, 0.60) 100%)"
				>
					<Text
						color="white"
						font="400 16px/1.5 --fontFamily-googleInter"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						"It's simple, useful, and impactful. Honestly, one of the best free tools out there!"
						<br />
						{" "}
					</Text>
					<Box
						min-width="100px"
						min-height="none"
						display="flex"
						flex-direction="row"
						align-items="center"
						align-content="center"
						justify-content="flex-start"
						margin="10px 0px 0px 0px"
					>
						<Image
							src="https://uploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22:09:42.748Z"
							display="block"
							width="65px"
							srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/brooke-cagle-k9XZPpPHDho-unsplash%201.png?v=2024-01-08T22%3A09%3A42.748Z&quality=85&w=3200 3200w"
							sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							justify-content="center"
							margin="0px 0px 0px 15px"
						>
							<Text
								color="white"
								font="normal 500 20px/1.6 --fontFamily-googlePoppins"
								pointer-events="auto"
								user-select="auto"
								margin="0px 0px 0px 0px"
							>
								Jimena L.
							</Text>
							<Text margin="0px 0px 7px 0px" font="normal 400 14px/1.5 &quot;Inter&quot;, sans-serif" color="rgba(255, 255, 255, 0.50)">
								Beta User
							</Text>
							<Image src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21:49:07.643Z" display="block" srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=3200 3200w" sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw" />
						</Box>
					</Box>
				</Box>
				<Box
					empty-min-height="64px"
					empty-border-width="1px"
					empty-border-color="LightGray"
					empty-min-width="64px"
					empty-border-style="solid"
					width="25%"
					md-width="100%"
					lg-width="50%"
					padding="25px 25px 25px 25px"
					border-style="none"
					margin="16px 10px 16px 10px"
					border-radius="10px"
					pointer-events="auto"
					background="rgba(48, 0, 95, 0.6)"
					border-width="0px"
					box-shadow="--m"
					hover-background="rgba(192, 128, 255, 0.25) linear-gradient(120deg,rgba(0,0,0,0) 0%,rgba(62, 0, 137, 0.60) 100%)"
					transition="all 0.5s ease-in-out 0s"
				>
					<Text
						color="white"
						font="400 16px/1.5 --fontFamily-googleInter"
						margin="0px 0px 0px 0px"
						pointer-events="auto"
						user-select="auto"
					>
						"This is so awesome! I can access my email, calendar, and my favourite AI tools all while I'm browsing."
					</Text>
					<Box
						min-width="100px"
						min-height="none"
						display="flex"
						flex-direction="row"
						align-items="center"
						align-content="center"
						justify-content="flex-start"
						margin="10px 0px 0px 0px"
					>
						<Image
							src="https://uploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22:56:12.905Z"
							display="block"
							width="65px"
							srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/ha-nguy-n-OFSQ6bHjFjs-unsplash%201.png?v=2024-01-08T22%3A56%3A12.905Z&quality=85&w=3200 3200w"
							sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
						/>
						<Box
							min-width="100px"
							min-height="100px"
							display="flex"
							flex-direction="column"
							align-items="flex-start"
							justify-content="center"
							margin="0px 0px 0px 15px"
						>
							<Text
								color="white"
								font="normal 500 20px/1.6 --fontFamily-googlePoppins"
								pointer-events="auto"
								user-select="auto"
								margin="0px 0px 0px 0px"
							>
								Jian H.
							</Text>
							<Text margin="0px 0px 7px 0px" font="normal 400 14px/1.5 &quot;Inter&quot;, sans-serif" color="rgba(255, 255, 255, 0.50)">
								Beta User
							</Text>
							<Image src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21:49:07.643Z" display="block" srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%20243%20%281%29.png?v=2024-01-08T21%3A49%3A07.643Z&quality=85&w=3200 3200w" sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw" />
						</Box>
					</Box>
				</Box>
			</Box>
			<Box
				min-width="100px"
				min-height="100px"
				display="flex"
				align-items="center"
				justify-content="center"
				margin="20px 0px 0px 0px"
				md-width="100%"
			>
				<Link
					sm-padding="15px 20px 15px 20px"
					hover-background="#6608ff"
					border-width="0px"
					border-style="solid"
					font="normal 500 18px/1.8 --fontFamily-googleInter"
					border-color="rgba(255, 255, 255, 0.3)"
					md-width="100%"
					md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
					text-decoration-line="initial"
					color="--indigo"
					md-text-align="center"
					padding="10px 35px 10px 35px"
					border-radius="5px"
					sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
					transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
					background="#ffffff"
					hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
					hover-border-width="0px"
					hover-color="#ffffff"
					href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
					target="_blank"
				>
					Download Now
				</Link>
			</Box>
		</Section>
		<Section sm-padding="60px 0 60px 0" lg-padding="60px 0 100px 0" padding="60px 0 60px 0" id="download">
			<Override
				slot="SectionContent"
				justify-content="center"
				align-items="center"
				padding="60px 0px 100px 0px"
				lg-padding="60px 0px 30px 0px"
				sm-padding="60px 0px 60px 0px"
			/>
			<Image
				src="https://uploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04:38:19.862Z"
				display="block"
				margin="0px 0px 30px 0px"
				width="60px"
				srcSet="https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/63a25993f63de40026725928/images/Group%2021%20%282%29.png?v=2023-01-28T04%3A38%3A19.862Z&quality=85&w=3200 3200w"
				sizes="(max-width: 460px) 100vw,(max-width: 767px) 100vw,(max-width: 992px) 100vw,100vw"
			/>
			<Text
				font="normal 600 40px/1 --fontFamily-googleInter"
				text-align="center"
				color="#374151"
				lg-font="normal 700 40px/1.2 &quot;Inter&quot;, sans-serif"
				sm-width="100%"
				sm-font="normal 700 30px/1.2 &quot;Inter&quot;, sans-serif"
				width="100%"
			>
				<Span
					font-weight="normal"
					lg-font="600 40px/48px --fontFamily-googlePoppins"
					font="600 40px/40px --fontFamily-googlePoppins"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					sm-font="600 28px/40px Inter, sans-serif"
				>
					Ready to join Aid-
					<Em
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						vertise
					</Em>
					?
				</Span>
			</Text>
			<Text
				margin="10px 0px 70px 0px"
				font="normal 600 20px/1 --fontFamily-googleInter"
				text-align="center"
				color="--darkL2"
				sm-width="100%"
				sm-font="normal 700 20px/1.2 &quot;Inter&quot;, sans-serif"
				width="100%"
				lg-font="normal 600 20px/1 --fontFamily-googleInter"
			>
				<Span
					font-weight="normal"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Let's start turning ads into aid
				</Span>
			</Text>
			<Link
				href="https://chromewebstore.google.com/detail/aid-vertise/clnahiecfdigjlgmealkpajafoedcobp"
				sm-padding="15px 20px 15px 20px"
				hover-background="#6608ff"
				border-width="0px"
				border-style="solid"
				font="normal 500 18px/1.8 --fontFamily-googleInter"
				sm-margin="0px 22px 0px 0px"
				border-color="rgba(255, 255, 255, 0.3)"
				md-width="100%"
				md-font="normal 500 16px/1.6 &quot;Inter&quot;, sans-serif"
				text-decoration-line="initial"
				color="--white"
				md-text-align="center"
				border-radius="5px"
				sm-font="normal 500 18px/1.6 &quot;Inter&quot;, sans-serif"
				transition="background-color 0.3s --transitionTimingFunction-easeInOut 0s"
				background="--color-indigo"
				md-margin="16px 0px 0px 0px"
				padding="10px 30px 10px 30px"
				hover-box-shadow="1px 2px 3px 0px rgba(0, 0, 0, 0.2)"
				target="_blank"
			>
				Download for Free
			</Link>
		</Section>
		<Components.Footer>
			<Override slot="linkBox6" />
		</Components.Footer>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6123949e957019001e284456"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\na[href=\"https://quarkly.io/\"]{\ndisplay: none;\n}"}
			</style>
			<style place={"endOfBody"} rawKey={"63ab46a125e1dd39903991f6"}>
				{"a[href=\"https://quarkly.io/\"]{\ndisplay: none;\n}"}
			</style>
			<meta
				charset={""}
				name={"theme-color"}
				content={"white"}
				http-equiv={""}
				place={"endOfHead"}
				rawKey={"63ab6040713fa2b8da76759a"}
			/>
			<script place={"endOfHead"} rawKey={"63d4a2ee3c792adefb43bfac"}>
				{"window.onscroll = function() {changeelementstyle()};\nfunction changeelementstyle() {\n  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {\n\t\tdocument.getElementById(\"navbar\").style.boxShadow = \"0 4px 6px 0 rgba(0,0,0,.2)\";\n\t\t\n  } else {\n\t\tdocument.getElementById(\"navbar\").style.boxShadow = \"0 0 0 0 rgba(0,0,0,.2)\";\n\t}\n}\n\nfunction openRightMenu() {\n\tdocument.getElementById(\"rightMenu\").style.display = \"block\";\n}\n\nfunction closeRightMenu() {\n  document.getElementById(\"rightMenu\").style.display = \"none\";\n}\n\nwindow.onload = function () {\n changeelementstyle()\n};"}
			</script>
			<style place={"endOfHead"} rawKey={"63d4a308d9f278c1afd3278b"}>
				{"#navbar {\n  background-color: white;\n  position: fixed;\n  display: flex;\n  transition: padding 0.4s, box-shadow .5s;\n  width: 100%;\n}\n\n#navbar a {\n  display: block;\n  text-align: center;\n  padding: 10px 0px 10px 0px;\n  font-size: 14px;\n}\n\n.contactnav{\n    float:right;     \n    display: block;\n    width: 180px;\n    height: 45px;\n    background: #8336ff;\n    text-align: center;\n    border-radius: 5px;\n    color: white;\n    font-weight: 500;\n    line-height: 25px;\n    font-family: \"Inter\", sans-serif;\n    margin-top: 5px;\n    transition: color 0.3s; \n}\n\n.contactnav:hover {\n  background-color: #6608ff;\n}\n\n.NFTnav {\n    float:right;     \n    display: block;\n    width: 150px;\n    height: 45px;\n    text-align: center;\n    border-radius: 5px;\n    color: #8336ff;\n    line-height: 25px;\n    margin-left: 20px;\n    margin-right: 15px;\n    margin-top: 5px;\n    font-weight: 600;\n    font-family: \"Inter\", sans-serif;\n    border-style: solid;\n    border-width: .8px;\n    border-color: #cbd5e1;\n    margin-bottom: 10px;\n    transition: color 0.3s; \n}\n\n.NFTnav:hover {\n  background: #f7f1ff;\n  border-color: #8336ff;\n  border-width: 1px;\n}\n\n#logo { \n  display: flex; \n  height: 35px;\n  transition: height 0.4s;\n}\n\n#logoside {  \n  height: 35px;\n  margin-bottom:20px;\n  margin-left:20px;\n}\n\n#hamburgermenu {\n  transition: padding 0.4s;\n  float:right;\n}\n\n#Contactnav, #nFTnav {\n  transition: border-color 0.6s, margin-top 0.4s, background-color 0.3s;\n  float:right;\n}\n\n#navbar a.active {\n  background-color: white;\n  color: white;\n}\n\n#navbar .Hamburgermenu {\n  display: none;\n}\n\n#rightMenu{\n  display:none;\n  position:fixed;\n  width:100%;\n  z-index:1000;\n  float:right;     \n  background: white;\n  width: 200px;\n  height: 100%;\n  box-shadow:0 0 0 10000px rgba(0,0,0,.50);\n  visibility: hidden;\n  font-size: 20px;\n  animation: animateright 0.4s\n}\n\n.bar-item{\n  font-weight: 450;\n  padding:8px 15px;\n  float:left;\n  width:100%;\n  border:none;\n  display:inline-block;\n  outline:0;\n  vertical-align:middle;\n  color:inherit;\n  background-color:inherit; \n  text-align:left;\n  overflow:hidden;\n  white-space:nowrap;\n}\n.closeout{\n  padding:8px 15px;\n  float:left;\n  width:100%;\n  border:none;\n  display:inline-block;\n  outline:0;\n  vertical-align:middle;\n  color:inherit;\n  background-color:inherit; \n  text-align:left;\n  overflow:hidden;\n  white-space:nowrap;\n}\n.bar-item:hover{\n  background-color: rgba(131, 54, 255, 0.07);\n}\n\n.activeside{\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n\n.centernavbar {\n    display: flex;\n    align-items: left;\n    justify-content: left;\n    font-weight: 450;\n\n}\n\n.centernavbarobjects{\n  margin-right: 30px;\n  font-family: 'Inter', sans-serif;\n  transition: padding 0.4s, color 0.3s;\n  color:  #5f6367;\n  display: inline-block;\n  position: relative;\n  height:100%;\n}\n\n@keyframes animateright{from{right:-300px;opacity:0} to{right:0;opacity:1}}\n\n@media screen and (max-width: 1180px) {\n  #navbar a:not(.active) {display: none;}\n  #navbar a.Hamburgermenu {\n    float: right;\n    display: block;\n  }\n  #rightMenu{\n    visibility: visible;\n  }\n\n}\n\n\n@media screen and (max-width: 400px) {\n  #navbar a:not(.active) {display: none;}\n  #navbar a.Hamburgermenu {\n    float: right;\n    display: block;\n  }\n  #rightMenu{\n    visibility: visible;\n  }\n#logo{\nmargin-top: 10px;\nheight: 25px;\n}\n\n}\n\n\n\n\na:link, a:visited, a:hover {\n  text-decoration:none;\n}\n"}
			</style>
			<script place={"endOfHead"} rawKey={"63d6f9c1eb319ed27ac6a558"}>
				{"window.onload = function () {\n\n// Cache selectors\nvar lastId,\n topMenu = $(\"#mainNav\"),\n topMenuHeight = topMenu.outerHeight()+1,\n // All list items\n menuItems = topMenu.find(\"a\"),\n // Anchors corresponding to menu items\n scrollItems = menuItems.map(function(){\n   var item = $($(this).attr(\"href\"));\n    if (item.length) { return item; }\n });\n\n// Bind click handler to menu items\n// so we can get a fancy scroll animation\nmenuItems.click(function(e){\n  var href = $(this).attr(\"href\"),\n      offsetTop = href === \"#\" ? 0 : $(href).offset().top-topMenuHeight+1;\n  $('html, body').stop().animate({ \n      scrollTop: offsetTop\n  }, 0);\n  e.preventDefault();\n});\n\n// Bind to scroll\n$(window).scroll(function(){\n   // Get container scroll position\n   var fromTop = $(this).scrollTop()+topMenuHeight;\n   \n   // Get id of current scroll item\n   var cur = scrollItems.map(function(){\n     if ($(this).offset().top < fromTop)\n       return this;\n   });\n   // Get the id of the current element\n   cur = cur[cur.length-1];\n   var id = cur && cur.length ? cur[0].id : \"\";\n   \n   if (lastId !== id) {\n       lastId = id;\n       // Set/remove active class\n       menuItems\n         .parent().removeClass(\"active\")\n         .end().filter(\"[href=#\"+id+\"]\").parent().addClass(\"active\");\n   }                   \n});\n\n\n};\n"}
			</script>
			<style place={"endOfHead"} rawKey={"63d6f9e43e25829bfe037297"}>
				{"ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  position: relative;\n  display: table;\n  margin: 0 auto;\n}\nul li {\n  display: table-cell;\n}\nul li a {\n  display: block;\n  color: white;\n  text-decoration: none;\n}\nul li a:hover {\n  color: #374151;\n}\n\nul .active a {\n  color: #374151;\n  border-bottom: 3px solid #8336ff;\n}\n\nsection {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  display: block;\n  z-index: 0;\n}\n"}
			</style>
			<script src={"https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.min.js"} place={"endOfHead"} rawKey={"63d6fa336fc98c1d91fb0e00"} />
			<script src={""} place={"endOfBody"} rawKey={"668b118571f710d414da79f9"} />
			<script async={true} src={""} place={"endOfHead"} rawKey={"668b12f46970d1e4fc5a2cea"}>
				{"<!-- Google tag (gtag.js) -->\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-SQL2FMVEYW\"></script>\n<script>\n  window.dataLayer = window.dataLayer || [];\n  function gtag(){dataLayer.push(arguments);}\n  gtag('js', new Date());\n\n  gtag('config', 'G-SQL2FMVEYW');\n</script>"}
			</script>
		</RawHtml>
	</Theme>;
});